/*!
 *
 * following.js
 *
 */

$.Following = function( _this, opt ){
	this.$elem = $(_this);
	this.base = this.$elem.attr('class');
	this.settings = $.extend({}, this.default, opt);
	this.init();
};

$.Following.prototype = {
	init: function(){
		if( !this.settings.pcSticky && !this.settings.spSticky ){
			this.$sticky = $( this.settings.sticky );
		}else{
			if( origin.VPisMobile ){
				this.$sticky = $( this.settings.spSticky );
			}else{
				this.$sticky = $( this.settings.pcSticky );
			};
		};
		this.border = this.$sticky.offset().top;

		this.isFollowing = false;
		this.scroll();

		origin.switchPoint = this.border;

		var self = this;
		this.$target = this.$elem;
		if( this.settings.pcMoveElem && !origin.VPisMobile ){
			this.$target = $( this.settings.pcMoveElem );
		};
		if( this.settings.spMoveElem && origin.VPisMobile ){
			this.$target = $( this.settings.spMoveElem );
		};


		origin.$window.on('changeMobile', function(){
			self.stopFollow();
			if( self.settings.pcSticky && self.settings.spSticky ){
				self.$sticky = $( self.settings.spSticky );
			};

			if( self.settings.spMoveElem ){
				self.$target = $( self.settings.spMoveElem );
			}else{
				self.$target = self.$elem;
			};
			self.border = self.$sticky.offset().top;
			origin.switchPoint = self.border;
			origin.$window.trigger('scroll');
		});

		origin.$window.on('changePC', function(){
			self.stopFollow();
			if( self.settings.pcSticky && self.settings.spSticky ){
				self.$sticky = $( self.settings.pcSticky );
			};

			if( self.settings.pcMoveElem ){
				self.$target = $( self.settings.pcMoveElem );
			}else{
				self.$target = self.$elem;
			};
			self.border = self.$sticky.offset().top;
			origin.switchPoint = self.border;
			origin.$window.trigger('scroll');
		});
	},
	scroll: function(){
		var self = this;
		origin.$window.on('scroll', function(){
			var _top = $(this).scrollTop();
			if( !self.isFollowing && _top > self.border && !$('body').is('.fixed') && !$('html').is('.fixed') ){
				self.startFollow();
			};
			if( self.isFollowing && _top <= self.border && !$('body').is('.fixed') && !$('html').is('.fixed') ){
				self.stopFollow();
			};
		});
	},
	startFollow: function(){
		var self = this;
		this.isFollowing = true;
		this.$elem.addClass( this.settings.fixed );
		// this.$target.transit({
		// 	y: '0%'
		// }, 600, 'easeOutQuart');
	},
	stopFollow: function(){
		var self = this;
		this.isFollowing = false;
		self.$elem.removeClass( self.settings.fixed );
		// this.$target.transit({
		// 	y: '-105%'
		// }, 200, 'easeOutQuart', function(){
		// 	$(this).removeAttr('style');
		// 	self.$elem.removeClass( self.base + '--' + self.settings.fixed );
		// });
	},
	default: {
		sticky: '.sticky',
		pcSticky: false,
		spSticky: false,
		fixed: 'fixed',
		pcMoveElem: false,
		spMoveElem: false
	}
};

$.fn.following = function(options){
	var opt = options ? options : {};
	new $.Following( this, opt );
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/components/module/following.js
// module id = 19
// module chunks = 0